import * as React from 'react'
import {Component, ReactElement} from 'react'
import {Location} from 'react-router-dom'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import NatUseFunctionMasterRepo from '../useFunctionMaster/repository/NatUseFunctionMasterRepo';


interface Props {
    condominiumCd: string
    useFunctionMasterRepo: NatUseFunctionMasterRepo
    location: Location
}

const FUNCTION_ID_APPLY_WEB_ACCOUNT_TRANSFER = 35;
const FUNCTION_ID_ACCOUNT_INFORMATION = 62;

class NatResidentAccountTransferPage extends Component<Props & ResidentWithErrorHandlingPagePropsSet> {
    constructor(props: Readonly<Props & ResidentWithErrorHandlingPagePropsSet>) {
        super(props)
    }

    async componentDidMount(): Promise<void> {
        const {condominiumCd, navigate} = this.props
        await this.props.eventEmitter.showLoading();
        try {
            const validUseFunctions = await NatAsyncCallFunction(
                this.props.useFunctionMasterRepo.getValidUseFunctionLoggedIn.bind(
                    this.props.useFunctionMasterRepo), this.props.navigate)
            if (validUseFunctions?.details) {
                if (validUseFunctions.details.validUseFunctionIdList.some(validUseFunction =>
                    validUseFunction === FUNCTION_ID_ACCOUNT_INFORMATION)) {
                    navigate(`/resident/condominiums/${condominiumCd}/account-transfer/info`)
                } else if (validUseFunctions.details.validUseFunctionIdList.some(validUseFunction =>
                    validUseFunction === FUNCTION_ID_APPLY_WEB_ACCOUNT_TRANSFER)) {
                    navigate(`/resident/condominiums/${condominiumCd}/applications/account-transfer/receiving-agency/redirect`)
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    render(): ReactElement {
        return <></>
    }
}

export default createResidentWithErrorHandlingPage(NatResidentAccountTransferPage)
